import React from 'react';
import { Path, Rect, Circle, Line, Polygon, Polyline, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const DownloadIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 17"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M17 10.1493V14.209C17 15.33 16.0912 16.2388 14.9702 16.2388L2.79104 16.2388C1.66999 16.2388 0.761194 15.33 0.761194 14.209V10.1493M13.3094 5.90502L8.8806 10.3338L4.45183 5.90502M8.8806 10.3338L8.8806 0"
      stroke={color}
      strokeWidth="1.5"
    />
  </Svg>
);

DownloadIcon.displayName = 'DownloadIcon';
